import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Gift, ArrowRight } from "lucide-react";
import { countryFlag, countryName } from "@/lib/countries";
import { useLang } from "@/context/LanguageContext";

export default function Join() {
  const { t } = useLang();
  const { code } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api(`/referrals/lookup/${code}`, { auth: false }).then(setInfo).catch(() => setInfo({ found: false }));
  }, [code]);

  return (
    <div className="max-w-lg mx-auto px-6 py-20 text-center">
      <div className="mx-auto h-16 w-16 grid place-items-center rounded-2xl findo-gradient text-white"><Gift size={32} /></div>
      <h1 className="mt-5 font-display text-3xl font-extrabold text-slate-900">{t("pub.invitedOnFindo")}</h1>
      {info?.found ? (
        <p className="mt-3 text-slate-600">
          <b>{info.referrer_org_name}</b> {info.country && <>({countryFlag(info.country)} {countryName(info.country)})</>} {t("pub.joinInvitesYou")}
        </p>
      ) : (
        <p className="mt-3 text-slate-600">{t("pub.joinFindoDesc")}</p>
      )}
      <div className="mt-8">
        <Button onClick={() => navigate(`/auth/register?ref=${code}`)} size="lg" className="rounded-full h-12 px-8 font-bold" data-testid="join-cta">
          {t("pub.createPartnerAccount")} <ArrowRight size={18} className="ml-1.5" />
        </Button>
      </div>
      <p className="mt-4 text-sm text-slate-400">{t("pub.referralCode")} <span className="font-mono font-bold text-findo-indigo">{code}</span></p>
      <div className="mt-10"><Link to="/"><Logo size={30} withText textClass="text-lg text-slate-400" /></Link></div>
    </div>
  );
}
